import { render, staticRenderFns } from "./AdminStatsFlights.vue?vue&type=template&id=570f43f6&"
import script from "./AdminStatsFlights.vue?vue&type=script&lang=js&"
export * from "./AdminStatsFlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports